import UserBottomNav from "../../components/common/UserBottomNav";
import Hero from "../users/Hero";
import Catagories from "./Categories";
import ChooseUs from "./ChooseUs";
import Counter from "./Counter";
import FAQs from "./FAQs";
import Gallery from "./Gallery";
import Insight from "./Insight";
import NewsLetter from "./NewsLetter";
import Package from "./Package";
import Testimonials from "./Testimonial";
import Work from "./Works";
const Home = () => (
  <div className=" relative overflow-hidden no-scrollbar max-w-9xl mx-auto pb-24 md:pb-0">
    <Hero />

    <section id="categories">
      <Catagories />
    </section>

    <section id="packages">
      <Package />
    </section>

    <section id="testimonials">
      <Testimonials />
    </section>

    <section id="counter">
      <Counter />
    </section>

    <section id="choose-us">
      <ChooseUs />
    </section>

    <section id="work">
      <Work />
    </section>

    <section id="gallery">
      <Gallery />
    </section>

    <section id="insight">
      <Insight />
    </section>

    <section id="faqs">
      <FAQs />
    </section>

    <section id="newsletter">
      <NewsLetter />
    </section>

    <UserBottomNav />
  </div>
);

export default Home;
